
import axios from "axios";
export const tableModule = {
    state: () => ({
        users: [],
        user_id: 0,
        user_form: {}

    }),
    getters: {
        GetUsers(state){
            return [...state.users]},
        GetUser(state, getters){
            let res = getters.GetUsers.filter(user => user.user_id === state.user_id)
            return res
        },
        GetUserForm(state){
            return state.user_form},

    },
    mutations: {
        setUsers(state, users){
            state.users = users
        },
        setUserId(state, user_id){
            state.user_id = user_id
        },
        setUserForm(state, user_form){
            state.user_form = user_form
        },
    },
    actions: {
        async fetchUsers({commit}){
            try {
                setTimeout(async () => {
                    const response = await axios.get('https://max-test-domain.site/get_users?key=eANH55sHJy3pF2I')
                    commit("setUsers", response.data)
                }, 500)
            
            }
            catch(e){alert('Произошла ошибка $(e)')}
            },
        async fetchUserForm({state, commit}){
            console.log('kekel');
            try {
                setTimeout(async () => {
                    const response = await axios.get(`https://max-test-domain.site/get_user_form?user_id=${state.user_id}&key=eANH55sHJy3pF2I`)
                    commit("setUserForm", response.data)
                }, 500)
            
            }
            catch(e){alert('Произошла ошибка $(e)')}
            },    
    },


}
